export const topAreas = [
    { name: "Washington DC", url: "Washington-DC" },
    { name: "Los Angeles", url: "Los-Angeles-CA" },
    { name: "New York", url: "New-York-NY" },
    { name: "Chicago", url: "Chicago-IL" },
    { name: "Houston", url: "Houston-TX" },
    { name: "Phoenix", url: "Phoenix-AZ" },
    { name: "Dallas", url: "Dallas-TX" },
    { name: "Tampa", url: "Tampa-FL" },
    { name: "San Diego", url: "San-Diego-CA" },
    { name: "Atlanta", url: "Atlanta-GA" },
    { name: "Sacramento", url: "Sacramento-CA" },
];
